import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useQuery } from '@tanstack/react-query';

export interface IEmailValidationError {
    errorCode: string;
    message: string;
}

export interface IValidateSignupUser {
    email: string;
    isDisabled: boolean;
}

export interface IValidateSignupOrg {
    name: string;
    hasDealAccess: boolean;
}

export interface IValidateSignupResponse {
    user?: IValidateSignupUser;
    org?: IValidateSignupOrg;
    emailValidationError?: IEmailValidationError;
}

const validateSignup = async (email: string): Promise<IValidateSignupResponse> => {
    const response = await axiosInstance.post(API_ENDPOINTS.SIGNUP.VALIDATE_SIGNUP, { email });
    return response.data;
};

export const useValidateSignup = (email: string, options?: any) => useQuery<IValidateSignupResponse, Error>({
    queryKey: [QUERY_KEYS.SIGNUP.VALIDATE_SIGNUP, email],
    queryFn: () => validateSignup(email),
    ...options,
});

export default useValidateSignup;
